<template>
  <top-view>
    <v-card id="cardView" class="mx-auto" :elevation="0" outlined>
      <div v-if="showErrorView" v-on:click="callLoadAllData" class="mx-auto"
        style="margin-top: 100px; width: 350px; height: 400px">
        <EmptyView class="mx-auto" />
      </div>
      <v-row v-if="!showErrorView" class="fill-height mr-0" max-height="100%">
        <v-col class="colum1" style="align-items: center">
          <div style="text-align: center; justify-content: center">
            <div style="max-width: 1050px; margin: auto">
              <date-time-picker :showErrorView="showErrorView" />
              <calendar />
            </div>
          </div>
        </v-col>
        <v-col class="colum2" v-show="!isMobile">
          <v-sheet class="v-sheet-calendar">
            <v-list-item id="listItem" three-line v-show="!showErrorView">
              <v-list-item-content style="height: 100%; margin: -1px -17px 0px -16px">
                <div id="flex-container">
                  <div class="tabItemSelect" style="justify-content: center; display: flex; align-items: center; ">
                    <tab-item :tabName="tab" class="btnLeftTab" v-on:tabItemClicked="handleTabItemClick"
                      v-for="tab in tabHeaders" v-bind:key="tab" v-bind:showThisTabItem="tab == activedTab"></tab-item>
                  </div>
                  <tab-header id="tabHeader"
                  v-on:createNewVacation="createVacation"
                  :style="computedStyle"></tab-header>
                  <div
                id="content"
                style="background: white; margin-top: 12px;"
              >
                <component
                  v-bind:is="selectedTabComponent"
                  :showErrorView="showErrorView"
                ></component>
              </div>
                  <!-- <page-navigation id="pageNavigation"></page-navigation> -->
                </div>
              </v-list-item-content>
            </v-list-item>
          </v-sheet>
        </v-col>
      </v-row>
    </v-card>
  </top-view>
</template>

<script>
  import Vue from 'vue';
  import TopView from '../../components/commonui/topView/TopView'
  import TabHeader from '../../components/home/TabHeader'
  import PageNavigation from '../../components/home/PageNavigation'
  import TabMyList from '../home/TabMyList';
  import TabRequesting from '../home/TabRequesting';
  import TabAll from '../home/TabAll';
  import { ListEvents, TabNames, resizeMixin,  getUserRole, isApprover, setLanguage} from "@/utilities/CommonUtilities";
  import {mapMutations, mapState} from 'vuex';
  import EmptyView from "../commonui/topView/ErrorView";
  import DateTimePicker from "../commonui/DateTimePicker";
  import Calendar from "./Calendar"; 
  import TabItem from "../commonui/TabItem";
  
  export default {
      mixins: [resizeMixin],
      components:{TopView, TabHeader, PageNavigation, TabAll, TabMyList, TabRequesting, EmptyView, DateTimePicker, Calendar, TabItem},
      data: () => ({
          showFilter: false, 
          localBus: new Vue(),
          isLoadDataCompleted: false,
          showErrorView: false,
          tabHeaders: [],
          activedTab: "",
      }),
      mounted() {
        this.notifyBus.$on(ListEvents.changeTabName, (tabName) => {
          let requestingTitle = this.$i18n.t("tab_inprogress_list");
          let approvedListTitle = this.$i18n.t("tab_approved_list");
          let myListTitle = this.$i18n.t("tab_my_list");

          if (tabName === TabNames.All) {
              this.tabHeaders = [approvedListTitle, requestingTitle];
          } else {
              this.tabHeaders = [myListTitle, requestingTitle];
          }
          this.activedTab = this.tabHeaders[0];
        });
        this.notifyBus.$on(ListEvents.vacationList, () => {
          this.initTabHeader(); 
        });
      },
      computed: {
        ...mapState(["listUser", "token", "listReason"]),
        ...mapState(["userInfo"]),
        ...mapState({
            currentTab: state => state.homeData.currentTab,
            selectedTab: (state) => state.homeData.selectedTab,
            currentLanguage: state => state.homeData.currentLanguage,
        }),
        computedStyle() {
          if (this.selectedTabComponent === TabRequesting) {
            return { "margin-bottom": "-50px" };
          } else {
            return '';
          }
        },
        selectedTabComponent() {
          if (this.selectedTab === TabNames.Requesting) {
            return TabRequesting;
          } else {
            if (this.currentTab === TabNames.MyList) {
              return TabMyList;
            } else {
              return TabAll;
            }
          }
        },
        showTitle() {
          if (this.isLoadDataCompleted) this.reloadData4ChangedTab();
          switch (this.currentTab) {
            case TabNames.MyList || TabNames.All:
              return this.$i18n.t("tab_my_list");
            case TabNames.Requesting:
              return this.$i18n.t("tab_inprogress_list");
            case TabNames.All:
              return this.$i18n.t("tab_approved_list");
          }
          return TabMyList;
        },
      },
      methods: {
          ...mapMutations({
              saveListUser: "saveListUser",
              saveListReason: "saveListReason",
              setSelectedTab: "homeData/setSelectedTab",
          }),
          initTabHeader() {
          let myListTitle = this.$i18n.t("tab_my_list");
          let requestingTitle = this.$i18n.t("tab_inprogress_list");
          let approvedListTitle = this.$i18n.t("tab_approved_list");
          this.tabHeaders =
            this.currentTab === TabNames.All
              ? [approvedListTitle, requestingTitle]
              : [myListTitle, requestingTitle];
          this.activedTab = this.getSelectedTab();
        },
        getSelectedTab() {
          return this.selectedTab === TabNames.All ? this.tabHeaders[0] : this.tabHeaders[1]
        },
        handleTabItemClick(tabName) {
          this.tabItemClicked(tabName);
        },
        tabItemClicked(tabName) {
          this.activedTab = tabName;
          var selectingTabName = TabNames.All;
          let index = this.tabHeaders.findIndex((p) => p == tabName);
          if (index == this.tabHeaders.length - 1) {
            selectingTabName = TabNames.Requesting;
          }
          this.setSelectedTab(selectingTabName);
        },
        isShowIconInProgress() {
          let userRole = getUserRole(this.userInfo.serviceInformation);
          return isApprover(userRole);
        },
          createVacation() {
            this.$router.push({name: "applyVacation", params: { option: 'create'}});
          },
          reloadData4ChangedTab() {
            this.showFilter = false;
          },
          async callLoadAllData() {
              if(!(this.listUser && this.listUser.length > 0)) {
                this.notifyBus.$emit(ListEvents.showLoadingIndicator);
                try{
                  let responseListUser = await this.dataSource.getData(this.dataSource.getAllUsersURL);
                  let listUser = responseListUser.data['users'];
                  this.saveListUser(listUser);
                  this.showErrorView = false;
                } catch(ex) {
                  this.showErrorView = true;
                  return;
                } finally {
                  this.notifyBus.$emit(ListEvents.hideLoadingIndicator);
                }
              }

              if(!(this.listReason && this.listReason.length > 0)) {
                this.notifyBus.$emit(ListEvents.showLoadingIndicator);
                try{
                    let params = {'token': this.token};
                    let responseListReason = await this.dataSource.getData(this.dataSource.listReason, params);
                    let listReason = responseListReason.data['types'];
                    this.saveListReason(listReason);
                  } catch(ex) {
                    this.showErrorView = true;
                    return;
                  } finally {
                    this.notifyBus.$emit(ListEvents.hideLoadingIndicator);
                  }
              }

              this.checkLoadDataDone();
          },
          checkLoadDataDone() {
            if((this.listReason && this.listReason.length > 0) && (this.listUser && this.listUser.length > 0)) {
              this.$nextTick(() => {
                this.localBus.$emit(ListEvents.loadDataCompleted);
              });
              this.isLoadDataCompleted = true;
            }
          },
          createNewVacation() {
            this.$emit("createNewVacation");
          },
          changeColor() {
            if (this.currentTab === TabNames.All) {
              return "#3fe090";
            } else if (this.currentTab === TabNames.MyList) {
              return "#C7C7C7";
            } else {
              return "#FEBD1F";
            }
          },
      },
      created() {
        //set language 
        setLanguage(this.currentLanguage);
        this.callLoadAllData();
        this.date = new Date().toISOString().substring(0, 7);
        this.initTabHeader();
      },
      inject: ["dataSource", "notifyBus"],
      provide: function () {
        return {
            homeViewBus: this.localBus
        }
    },
  }
</script>

<style scoped>
  #flex-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: stretch;
    padding: 0 0 0 15px;
  }
 #cardView{
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border-color: #ffffff;
  border-radius:0px;
 }
 #tabHeader{
   width: 100%;
   height: 52px;    
   padding-bottom: 10px;
 }
 .tabItemSelect{
  margin-left: -15px;
 }
 ::v-deep .dynamic-component-tab-button{
  width: 203px;
 }
 #listItem{
    width: 100%;
    height: 100%;  
    box-shadow: -4px 0 8px rgba(0, 0, 0, 0.1);
 }
 
 .v-list-item__content {
   padding: 0px;
 }
 #pageNavigation{
   width:100%;
   height: 50px; 
   padding-top: 10px;
 }
 #filterView {
   position: fixed;
   top: 90px;
   right: 40px;
   z-index: 4;
 }

 #content {
    margin-bottom: 5px;
    background-color: green; 
    width: 100%; 
    height: 100%;
    object-fit: cover;
    overflow-x: hidden; 
    overflow-y: scroll; 
    text-align:justify;
  }

  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
  }

#content::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, .5);
    box-shadow: 0 0 1px rgba(255, 255, 255, .5);
  }

  .v-date-picker .v-picker__title {
    font-weight: normal !important;
  }

  .colum1 {
    flex: 3;
    margin-left: 25px;
    margin-right: 10px;
  }

  .colum2 {
    flex: 1;
    padding: 0px;
    text-align: center;
    justify-content: right;
    display: flex;
    height: 100%;
  }

  .v-sheet-calendar {
    height: 108%;
    width: 405px;
    float: right;
  }

@media only screen and (max-width: 720px) {
   #filterView {
   position: fixed;
   top: 90px;
   right: 12px;
   z-index: 4;
  }

  #listItem {
    width: 95%;
    height: 100%;
    margin: 0 auto;
    /*control  horizontal*/
  }
  .colum2{
    justify-content: center;
    margin-left: 5px;
  }
}
  .vacation-list {
    height: 30px;
    background-color: rgb(121, 214, 121);
  }

  ::v-deep .no-gutters {
    height: 70px !important;
  }

  @media (max-width: 767px) {
  .colum1{
    margin-left: 0px !important;
    margin-right: 0px;
    padding-right: 0px;
    padding-top: 0px;
height: auto;
  }
  .v-sheet.theme--light {
    margin-right: 0.5px !important;
  }
  ::v-deep .no-gutters {
    margin-bottom: -14px !important;
  }
}
</style>
